<da-single-stage [data]="'bookingError.singleStage' | translate"></da-single-stage>
<section class="background-color-nearwhite">
    <da-teaser-boxes-container [data]="'bookingError.teaserBox' | translate"></da-teaser-boxes-container>
</section>
